import { deleteOnboardingDocument } from 'commons/service/bank/onboardingDocuments'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteOnboardingDocument: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(deleteOnboardingDocument, opts)
